export default function PromotionsPage({ promotions }) {
  return (
    <section className="page-section promotions-page" data-testid="promotions-page">
      <div className="page-intro promotions-intro">
        <span className="eyebrow" data-testid="promotions-eyebrow">Promociones</span>
        <h1 data-testid="promotions-title">Promociones</h1>
        <p data-testid="promotions-description">Todas las promociones disponibles de Nossa estarán expuestas aquí para que puedas consultarlas antes de venir.</p>
        <div className="promotions-conditions" data-testid="promotions-conditions">
          Las promociones están sujetas a condiciones y se deben consultar con el personal antes de pedir.
        </div>
      </div>

      <div className="promotions-grid" data-testid="promotions-grid">
        {promotions.map((promotion) => (
          <article className="promotion-card" key={promotion.id} data-testid={`promotion-card-${promotion.id}`}>
            <div className="promotion-image-wrap">
              <img src={promotion.image_url} alt={promotion.title} data-testid={`promotion-image-${promotion.id}`} />
            </div>
            <div className="promotion-content">
              <span data-testid={`promotion-label-${promotion.id}`}>Promo activa</span>
              <h2 data-testid={`promotion-title-${promotion.id}`}>{promotion.title}</h2>
              <p data-testid={`promotion-description-${promotion.id}`}>{promotion.description}</p>
              <small data-testid={`promotion-note-${promotion.id}`}>{promotion.note}</small>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}